import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Login from './components/Login';
import DashboardPage from './pages/DashboardPage';
import EmailCoveragePage from './pages/EmailCoveragePage';
import GmailSyncHealthPage from './pages/GmailSyncHealthPage';
import AudienciasPage from './pages/AudienciasPage';
import ContatosPage from './pages/ContatosPage';
import ImoveisPage from './pages/ImoveisPage';
import SyncStatusPage from './pages/SyncStatusPage';
import FilaEmpresasPage from './pages/FilaEmpresasPage';
import OfertasPage from './pages/OfertasPage';
import ProprietariosPage from './pages/ProprietariosPage';
import IntakePage from './pages/IntakePage';
import KnowledgePage from "./pages/KnowledgePage";
import ListasPage from './pages/ListasPage';
import AgendaPage from './pages/AgendaPage';
import LaunchesDashboardPage from './pages/LaunchesDashboardPage';
import LaunchDealsPage from './pages/LaunchDealsPage';
import LaunchesEmpreendimentosListPage from './pages/LaunchesEmpreendimentosListPage';
import LaunchEmpreendimentoDetailPage from './pages/LaunchEmpreendimentoDetailPage';
import LaunchDealDetailPage from './pages/LaunchDealDetailPage';
import ReviewWorkbenchPage from './pages/ReviewWorkbenchPage';
import RelationshipsPage from './pages/RelationshipsPage';
import InboxTriagePage from './pages/InboxTriagePage';
import { BusinessUnitProvider } from './contexts/BusinessUnitContext';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-600">Carregando sessão...</div>
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <BrowserRouter>
      <BusinessUnitProvider>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/inbox/triage" element={<InboxTriagePage />} />
          <Route path="/ai-health/email-coverage" element={<EmailCoveragePage />} />
          <Route path="/ai-health/gmail-sync" element={<GmailSyncHealthPage />} />
          <Route path="/audiencias" element={<AudienciasPage />} />
          <Route path="/contatos" element={<ContatosPage />} />
          <Route path="/imoveis" element={<ImoveisPage />} />
          <Route path="/sync" element={<SyncStatusPage />} />
          <Route path="/fila-empresas" element={<FilaEmpresasPage />} />
          <Route path="/ofertas" element={<OfertasPage />} />
          <Route path="/proprietarios" element={<ProprietariosPage />} />
          <Route path="/intake" element={<IntakePage />} />
          <Route path="/review" element={<ReviewWorkbenchPage />} />
          <Route path="/relationships" element={<RelationshipsPage />} />
          <Route path="/knowledge" element={<KnowledgePage />} />
          <Route path="/listas" element={<ListasPage />} />
          <Route path="/agenda" element={<AgendaPage />} />
          <Route path="/launches" element={<LaunchesDashboardPage />} />
          <Route path="/launches/deals" element={<LaunchDealsPage />} />
          <Route path="/launches/deals/:id" element={<LaunchDealDetailPage />} />
          <Route path="/launches/empreendimentos" element={<LaunchesEmpreendimentosListPage />} />
          <Route path="/launches/empreendimentos/:id" element={<LaunchEmpreendimentoDetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BusinessUnitProvider>
    </BrowserRouter>
  );
}

export default App;
